import { Component, OnInit,Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { TermsAndConditionsService } from '../../services/terms-and-conditions.service';
import { BaseManagement } from 'src/app/core/services/base-management';
import { DataSource } from '@angular/cdk/collections';

@Component({
  selector: 'terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent  extends BaseManagement implements OnInit {
	msg: any;
	agreeText: any;
	form : FormGroup;
	
	constructor(
		private formBuilder: FormBuilder,
		public mainService: TermsAndConditionsService,
	
	) {
		super()
		
		this.form = this.formBuilder.group({
			agreeBox:[{}],
		  });
		  if(this.mainService.terms){
			
		  }
	}

	ngOnInit() {
		this.form.controls.agreeBox.setValue(false);
	}

	submit(){
		if(this.form.controls.agreeBox.value == true){

			this.mainService.userAcceptsTerms = true;

			// this.close();
			
			this.mainService.userAcceptedTerms
			.next(this.mainService.userAcceptsTerms);
		}
		
	}
	close() {
		this.mainService.termsIsVisible = false;
	}
}
